import { theme } from '@acorns/web-components'
import styled from 'styled-components'

import {
  RECAP_MEDIUM_BREAKPOINT,
  RECAP_XS_BREAKPOINT,
  fonts,
  publishingColors,
} from '../../styles'

interface Props {
  detailOnRight?: boolean
  zIndex?: string
}

export const Container = styled.section`
  display: flex;
  height: 100vh;
  justify-content: center;
  max-height: 640px;
  padding: 120px 0;
  position: relative;
  width: 100%;

  @media screen and (max-width: ${RECAP_MEDIUM_BREAKPOINT - 1}px) {
    max-height: initial;
    height: 100%;
    padding: 100px 0;
  }

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    height: 100%;
    padding: 30px 0;

    &:last-of-type {
      margin-bottom: 10px;
      padding-bottom: 0;
    }
  }
`

export const Content = styled.div<Props>`
  align-items: center;
  display: flex;
  flex-direction: ${(props) => (props.detailOnRight ? 'row-reserve' : 'row')};
  justify-content: center;
  margin-left: 50px;
  margin-right: 50px;
  position: relative;
  width: 800px;
  z-index: ${(props) => props.zIndex || '1'};

  @media screen and (max-width: ${RECAP_MEDIUM_BREAKPOINT - 1}px) {
    flex-direction: ${(props) =>
      props.detailOnRight ? 'column-reverse' : 'column'};
    width: 400px;
  }

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    margin: 0;
    width: 100%;
  }
`

export const DetailContainer = styled.div<Props>`
  flex-direction: column;
  display: flex;
  justify-content: center;
  height: 400px;
  width: 400px;
  padding-left: ${(props) => (props.detailOnRight ? '80px' : 0)};
  padding-right: ${(props) => (props.detailOnRight ? 0 : '80px')};

  @media screen and (max-width: ${RECAP_MEDIUM_BREAKPOINT - 1}px) {
    padding-left: 0;
    height: initial;
    margin-bottom: 50px;
  }

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    justify-content: center;
    margin-bottom: 15px;
    padding: 0 30px;
    width: 100%;
  }
`

export const Title = styled.h2`
  ${fonts.AN_30_600_38}
  color: ${theme.colors.white};
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
`

export const Text = styled.p`
  ${fonts.AN_14_600_22}
  color: ${theme.colors.beige};
  margin-top: 0;
  margin-bottom: 10px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }
`

export const InteractiveBackground = styled.div`
  background-color: ${publishingColors.backgroundBlack};
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  height: 400px;
  justify-content: flex-end;
  overflow: hidden;
  position: relative;
  width: 400px;

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    background-color: initial;
    height: 100%;
    overflow: initial;
    width: 100%;
  }
`
